<template>
  <div class="location-wrapper">
    <div v-if="config" class=" text-center py-2" v-html="config.title"></div>
    <div class=" w-100" v-if="config">
      <el-image :src="config.poster" :preview-src-list="[config.poster]" class=" w-100" alt=""></el-image>
    </div>
    <div class=" w-100 fs-12 text-muted text-center my-1">点击查看大图</div>
    <div  class=" w-100 text-center text-link" @click="openpdf"><span> <i class="bi bi-filetype-pdf"></i> 展位图PDF版</span></div>
    <div class=" p-3" v-if="location_list && location_list.length > 0">
      <el-form ref="formData" :model="formData" label-width="80px" label-position="top">
      <el-form-item label="公司名称">
        <el-input v-model="formData.company" placeholder="请填写公司名称"></el-input>
      </el-form-item>
      <el-form-item label="公司简称">
        <el-input v-model="formData.company_short" placeholder="请填写公司简称"></el-input>
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="formData.name" placeholder="请填写联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="formData.phone" placeholder="请填联系电话"></el-input>
      </el-form-item>
      <el-form-item label="选择展位">
        <div class=" d-flex flex-wrap">
          <div class=" w-50 p-1" v-for="item in location_list" :key="item.index">
            <div class="border  p-1 rounded h-100 " :class="[isActive(item.code) ? 'location-active border-white' : '', item.status !== 0 ? 'bg-light text-muted border-white' : ''] " @click="selLocation(item)">
              <div class=" lh-lg">
                <i class="bi bi-check2-circle me-1" v-if="item.status !== 0"></i>
                <i class="bi bi-circle me-1 text-muted" v-if="!isActive(item.code) && item.status == 0"></i>
                <i class="bi bi-check-circle me-1" v-if="isActive(item.code) && item.status == 0"></i>{{ item.code }}
                <span class=" fs-12" v-if="item.status !== 0">(已预订)</span>
              </div>
              <div class=" fs-12 lh-1 ms-1 text-truncate text-muted" v-if="item.name !== '-'">{{ item.name !== '-' ? item.name : '' }}</div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item class=" text-center">
        <el-button type="primary" @click="onSubmit">提交预定</el-button>
      </el-form-item>
    </el-form>
    </div>
    
    <div v-if="sel_location.length > 0" class=" position-fixed start-0 bottom-0 bg-white px-3 py-2 w-100 shadow-lg">
      <div class=" mb-2">已选定展位: </div>
      <el-tag
        v-for="tag in sel_location"
        :key="tag"
        @close="handleClose(tag)"
        closable
        class="me-1 mb-1"
        type="success">
        {{tag}}
      </el-tag>
    </div>
  </div>
</template>
<script>
import ExhibitinService from '../../service/ExhibitinService'
export default {
  data() {
    return {
      location_list: [],
      formData: {
        ex_id: this.$route.query.ex_id,
        company: '',
        name: '',
        phone: '',
        position: '',
        company_short: ''
      },
      sel_location: [],
      config: null
    }
  },
  methods: {
    getLocationList() {
      ExhibitinService.getLocation({ ex_id: this.$route.query.ex_id }).then(res => {
        this.location_list = res
      })
    },
    isMsg() {
      if (this.sel_location.length <= 0) {
        return '请选择展位'
      }
      if (!this.formData.company) {
        return '请填写公司名称'
      }
      if (!this.formData.company_short) {
        return '请填写公司简称'
      }
      if (!this.formData.name) {
        return '请填写联系人'
      }
      if (!this.formData.phone) {
        return '请填写联系电话'
      } else {
        var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.formData.phone)) {
          return '请填写正确联系电话'
        }
      }
    },
    onSubmit() {
      let msg = this.isMsg()
      if (msg) {
        this.$message({
          message: msg,
          type: "warning",
        });
      } else {
        this.formData.position = this.sel_location.join(',')
        // this.formData.position = 'E001'
        ExhibitinService.reserveLocation(this.formData).then(res => {
          this.$message({
            message: '预约成功，展位已锁定',
            type: "success"
          })
          this.getLocationList()
          this.formData = {
            ex_id: this.$route.query.ex_id,
            company: '',
            name: '',
            phone: '',
            position: '',
            company_short: ''
          }
          this.sel_location = []
        }).catch(err => {
          this.$message({
            message: err.response.data.detail,
            type: "error"
          })
        })
      }
    },
    selLocation(item) {
      if (item.status == 0) {
        if (this.sel_location.indexOf(item.code) == -1) {
          this.sel_location.push(item.code)
        } else {
          this.sel_location.splice(this.sel_location.indexOf(item.code), 1)
        }
      }
    },
    isActive(code) {
     if (this.sel_location.indexOf(code) !== -1) return true
    },
    openpdf() {
      window.open(this.config.pdf)
    },
    handleClose(tag) {
      this.sel_location.splice(this.sel_location.indexOf(tag), 1)
    },
    getConfig() {
      ExhibitinService.getConfig({ type: 'Exhibition', key: 'PositionReserve_33' }).then(res => {
        this.config = res
      })
    }
  },
  mounted() {
    this.getConfig()
    this.getLocationList()
    document.title = '展位预定-国际房车露营展览会'
  }
}
</script>
<style>
.location-wrapper{
  /* max-width: 750px; */
  margin: 0 auto;
  padding-bottom: 220px;
}
.location-wrapper .el-form-item{
  margin-bottom: 10px;
}
.location-wrapper .el-form-item__label{
  line-height: normal;
}
.location-active{
  background: #028fff;
  color: #fff;
}
</style>